import React from 'react';
import { Check, X, Info } from 'lucide-react';
import styles from './Toast.module.css';

const ICONS = {
  success: <Check size={15} strokeWidth={2} />,
  danger:  <X     size={15} strokeWidth={2} />,
  info:    <Info  size={15} strokeWidth={1.75} />,
};

function ToastItem({ message, variant = 'success', exiting }) {
  return (
    <div className={`${styles.toast} ${styles[variant] || ''} ${exiting ? styles.exiting : ''}`}>
      <span className={styles.icon}>{ICONS[variant] ?? ICONS.info}</span>
      <span className={styles.message}>{message}</span>
    </div>
  );
}

export function ToastContainer({ toasts }) {
  if (!toasts || toasts.length === 0) return null;
  return (
    <div className={styles.container}>
      {toasts.map((t) => (
        <ToastItem key={t.id} message={t.message} variant={t.variant} exiting={t.exiting} />
      ))}
    </div>
  );
}
